import { useEffect, useRef, useState } from "react";
import { MultiSelect } from 'primereact/multiselect';

import './CustomMultiSelectGroup.css'

function OptionTemplateComponent({ option, options, selectedOptions, setSelectedOptions, doOnChange = undefined }) {
  const inputCheckBoxDOMRef = useRef(null)
  const multiSelectRef = useRef(null)

  useEffect(() => {
      const checkBoxRef = inputCheckBoxDOMRef.current

      const optionGroup = options.find(group => group.value === option.value)

      const numberOfNestedOptions = optionGroup.items.length
      const numberOfSelectedNestedOptions = optionGroup.items.reduce((sum, item) => {
        if(selectedOptions?.includes(item.value)) sum++
        return sum
      }, 0)

      if(numberOfNestedOptions === numberOfSelectedNestedOptions)
        checkBoxRef.checked = true
      else
        checkBoxRef.checked = false
  }, [selectedOptions])

  function handleGroupSelection(groupValue, checked) {
    const updatedSelection = [...(selectedOptions || [])];

    options.find((group) => group.value === groupValue)?.items.forEach((item) => {
        if (checked && !selectedOptions?.includes(item.value)) {
            updatedSelection.push(item.value);
        } else if (!checked && selectedOptions?.includes(item.value)) {
            const index = updatedSelection.indexOf(item.value);
            if (index !== -1) {
                updatedSelection.splice(index, 1);
            }
        }
    });

    setSelectedOptions(updatedSelection);
    if(typeof doOnChange === 'function'){
      doOnChange(updatedSelection)
    } 
  };

  return (
    <div className="p-multiselect-item-group-wrapper" onClick={() => {
      inputCheckBoxDOMRef.current.click();
    }}>
      <div className="p-checkbox p-component p-checkbox-group-wrapper">
        <input className="p-checkbox-group"
          type="checkbox"
          ref={inputCheckBoxDOMRef}
          onClick={e => e.stopPropagation()}
          onChange={e => handleGroupSelection(option.value, e.target.checked)}
        />
      </div>
      <label>{option.label}</label>
    </div>
  );
}

function CustomMultiSelectGroup({ options, placeholder, selectedOptions, setSelectedOptions, className, required, pattern, domRef, onFocus, disabled, doOnChange = undefined, formatValuesOnFill = undefined }) {
    const [ filteredOptions, setFilteredOptions ] = useState(options);
    const multiSelectRef = useRef(null);

    useEffect(() => {
      setFilteredOptions(options)
    }, [ options, filteredOptions ])

    function optionTemplate(option) {
        if (option.items) {
          return <OptionTemplateComponent option={option} options={options} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} doOnChange={doOnChange} />
        }
        return (
          <div className="custom-option">
            {option.label}
          </div>
        );
    };

    function fillSelectedOptions(keyDown) {
      if(keyDown.key === 'Enter' && typeof formatValuesOnFill !== 'undefined') {
        const inputValues = keyDown.target.value.split(';');
        if(inputValues.length > 1) {
          const values = formatValuesOnFill(inputValues).concat(selectedOptions || []);
          const valuesSemDuplicatas = [... new Set(values)];

          setSelectedOptions(valuesSemDuplicatas);
          doOnChange(valuesSemDuplicatas);

          multiSelectRef.current.hide();
        }
      }
    }

    function returnEmptyFilter(input) {
      if(input.filterValue.includes(";")) {
        return "Modo multi-seleção, digite os valores separado por ';'"
      } else {
        return "Não foram encontradas opções com estes filtros"
      }
    }

      return (
        <div className="custom-multi-select-relative-wrapper">
          <input ref={domRef} className="validator-notifier" type="text" />
          <MultiSelect
              ref={multiSelectRef}
              value={selectedOptions}
              options={filteredOptions}
              optionLabel="label"
              optionGroupLabel="label"
              optionGroupChildren="items"
              optionGroupTemplate={optionTemplate}
              onChange={(e) => { 
                setSelectedOptions(e.value) 
                if(typeof doOnChange === 'function'){
                  doOnChange(e.value)
                }
              }}
              onKeyDown={fillSelectedOptions}
              filter
              placeholder={placeholder}
              className={`custom-multiselect ${className || ''}`}
              emptyFilterMessage={returnEmptyFilter}
              emptyMessage="Não há opções para selecionar"
              required={required}
              pattern={pattern}
              onFocus={onFocus}
              disabled={disabled}
              resetFilterOnHide
          />
        </div>
      )
}

export default CustomMultiSelectGroup